export default __webpack_public_path__ + "static/media/logo.3515da33.png";